import {useState} from "react"
import {createModel} from "hox"

function useRadioError() {
    const [radioError, setRadioError] = useState(false)
    const [message, setMessage] = useState("麦克风异常，请检查麦克风是否启用")
    const toFalse = () => {
        setRadioError(false)
    }

    const toTrue = () => {
        setRadioError(true)
    }

    const reverse = () => {
        setRadioError((prev) => !prev)
    }

    return {
        value: radioError,
        toTrue,
        toFalse,
        reverse,
        message,
        setMessage,
    }
}

export default createModel(useRadioError)
